import { CHANGE_PAGE } from './types';

export const changePage = data => ({
  type: CHANGE_PAGE,
  data
});